import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface CvpUpdateSubmittedAnonymousResponse extends BackendResponse {
  item: string; // url
}

export interface CvpUpdateSubmittedAnonymousParameters extends NextApiParams {
  token: string;
}

export const updateSubmittedAnonymous = withNextApi<
  CvpUpdateSubmittedAnonymousResponse,
  CvpUpdateSubmittedAnonymousParameters
>("/cvp/CvpUpdateSubmittedAnonymous", { method: "POST" });
